export enum ApplicationStatus {
    FULLY_PAID = 'FULLY_PAID',
    ACTIVE = 'ACTIVE',
    DECLINED = 'DECLINED',
    RETURNED_FOR_ASSIGNMENT = 'RETURNED_FOR_ASSIGNMENT',
    PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
    ASSIGNED = 'ASSIGNED',
}

export enum CommissionType {
    PERCENTAGE = 'PERCENTAGE',
    FIXED_AMOUNT = 'FIXED_AMOUNT',
}

export enum LoanApplicationSalesType {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
}
